import {nanoid} from 'nanoid'

export default {
    namespaced:true,

    //准备actions--用于响应组件中的actions
    actions: {
        
    },

    //准备mutations--用于操作数据
    mutations: {
        ADDPERSONS(minstate, value) {
            minstate.MyPersons.length = 0 /* 清空数组 */
            for (let i = 0; i < value.length; i ++ ) {
                minstate.MyPersons.push({
                    id:value[i].id,
                    name:value[i].name,
                    pho:value[i].pho,
                    msg:'',
                    msgs:[],
                })
            }
            console.log(minstate.MyPersons)
            // minstate.id = value.id
            // minstate.name = value.name
            // minstate.pho = value.pho
        },
        UPDATERECEIVEID(minstate, value) {
            minstate.receiveId = value  /* 更新接收者id */
        },
        UPFRIEND(state, value) {
            state.firend = value;
        },
    },

    //创建getters 用于对state的数据进行加工
    getters: {
        
    },

    //准备state--用于存储数据
    state: {
        name:'', /* 用户昵称 */
        zh:'', /* 用户名 */
        password:'', /* 密码 */
    
        receiveId:'',/* 消息接收者的id */
        MyPersons:[],
        firend:[],
    },
}